var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewsNormal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5832 6.50267H9.74988V5.41211H20.5832V6.50267Z",
    fill: "#002852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74988 8.66211H20.5832V9.75267H9.74988V8.66211Z",
    fill: "#002852"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5832 13.0027H9.74988V11.9121H20.5832V13.0027Z",
    fill: "#002852"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1665 16.2527H9.74988V15.1621H15.1665V16.2527Z",
    fill: "#002852"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4963 2.16211H23.8369V21.1241C23.8369 22.6236 22.6245 23.836 21.1249 23.836H4.87491C3.37532 23.836 2.16296 22.6236 2.16296 21.1241V5.41211H6.4963V2.16211ZM7.58685 3.25266V6.50266H3.25352V21.1241C3.25352 22.0213 3.97762 22.7454 4.87491 22.7454H21.1249C22.0222 22.7454 22.7463 22.0213 22.7463 21.1241V3.25266H7.58685Z",
    fill: "#002852"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58682 5.95898V21.1256C7.58682 22.6252 6.37446 23.8376 4.87488 23.8376V22.747C5.77217 22.747 6.49627 22.0229 6.49627 21.1256V5.95898H7.58682Z",
    fill: "#002852"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewsNormal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news_normal.b84b074340b43282a16dfe624d7b8602.svg";